// @flow
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import OutletFilterDropdown from 'components/atoms/outletLocationFilter';
import { DisplayTime } from 'components/atoms/displayTime';
import { FilterButton } from 'components/atoms/filtersButton';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { groupBy } from 'lodash';
import { RouteNames } from 'router';
//eslint-disable-next-line
import styles from "./styles.scss";

const UpcomingEventsOverlayMobile = props => {
  const { data, activeFilters } = props;
  const groupData = (key, temp_data) => {
    let dateSort = temp_data.sort(function(a, b) {
      return new Date(a.date) - new Date(b.date);
    });
    return groupBy(dateSort, key);
  };
  const [groupDropDown, createGroupDropDown] = useState(
    groupData('monthName', data)
  );
  const [selected_drop_down_index, set_selected_drop_down_index] = useState(0);
  let dropDownData = [];
  useEffect(() => {
    createGroupDropDown(groupData('monthName', data));
  }, [data]);

  Object.keys(groupDropDown).map(drop_down_data => {
    dropDownData.push({
      name: drop_down_data,
      events_data: groupData('mobileFullDate', groupDropDown[drop_down_data]),
    });
  });

  const renderOutletDropDown = (
    <OutletFilterDropdown
      className={'location-dropdown'}
      dropDownName={
        dropDownData.length > 0
          ? dropDownData[selected_drop_down_index].name
          : ''
      }
      dropDownContent={dropDownData}
      onClick={(location, index) => set_selected_drop_down_index(index)}
      selectedDropDownOption={selected_drop_down_index}
    />
  );
  const onEventClick = urlSlug => {
    RouteUtil.setRouteChange(props, `${RouteNames.musicEvents}/${urlSlug}`);
  };

  return (
    <div className={'upcoming-events-overlay-mobile-container'}>
      <FilterButton
        className={`project-filter-mobile ${
          activeFilters.length > 0 ? 'highlight' : ''
        }`}
        filterType={'upcoming-events-filter-mobile'}
        activeFilters={activeFilters}
        filterContent={[]}
        isMobile={true}
      />
      {renderOutletDropDown}
      <h2> All Upcoming Events</h2>
      <h3 className={'overlay-subheading'}>
      Experience music that touches your soul and evokes emotions, from artistes across the globe in our world-class jazz theatre
      </h3>
      <div className={'events-mobile-layout'}>
        {dropDownData.length > 0
          ? Object.keys(dropDownData[selected_drop_down_index].events_data).map(
              events => {
                const card_data =
                  dropDownData[selected_drop_down_index].events_data[events];
                return (
                  <div className={'events-grid'}>
                    <div className={'group-info'}>
                      <span className={'info-type'}>{events}</span>
                      <div className={'horizontal-bar'}></div>
                    </div>
                    {card_data.map(event_data => {
                      return (
                        <div className={'upcoming-event-card'}>
                          <div
                            className={'image-container'}
                            onClick={() => onEventClick(event_data.url_slug)}
                          >
                            <img
                              src={event_data.imageMobile}
                              alt={'Event-Image'}
                            />
                          </div>
                          <div className={'event-info-container'}>
                            <h2
                              className={'event-name'}
                              onClick={() => onEventClick(event_data.url_slug)}
                            >
                              {event_data.name}
                            </h2>
                            <div className={'event-sub-info'}>
                              <h3 className={'event-genre'}>
                                {event_data.genre}
                              </h3>
                              <DisplayTime
                                start_time={event_data.startTime}
                                end_time={event_data.endTime}
                              />
                              <h3 className={'event-venue'}>
                                {event_data.venue}
                              </h3>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }
            )
          : null}
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    activeFilters: EventSelector.getActiveUpcomingEventFiltersNames(state),
  };
};
const mapDispatchToProps = dispatch => {
  const { toggleEventFilter } = EventActions;
  return bindActionCreators({ toggleEventFilter }, dispatch);
};
const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpcomingEventsOverlayMobile);
export default withRouter(connectedComponent);
